import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useFeatures } from "./use-features";
import useUserInfo from "./use-user-info";
import { getLegacyNameForPath } from "@/constants/screen-route-names";

export const useFeatureName = (screenRoutePath?: string) => {
  const userInfo = useUserInfo();
  const { data: features } = useFeatures(userInfo);
  const { pathname } = useLocation();

  return useMemo(() => {
    const cleanPath = screenRoutePath ?? pathname.replace(/^\/+|\/+$/g, "");
    const legacyName = getLegacyNameForPath(cleanPath);

    const matchedFeature = features?.find((feature) => {
      return cleanPath === feature.action?.web_route;
    });

    // console.log("usePageTitle", { matchedFeature, cleanPath, legacyName });
    return matchedFeature?.name ?? legacyName;
  }, [features, pathname, screenRoutePath]);
};
